module.exports = __webpack_public_path__ + "img/ic_medal.1d4cecb4.svg";